import { Link } from "react-router-dom"
import { Modal } from "bootstrap"
const AdminCardButtons = ({
  product,
  setUpdated,
  setCurrentProduct,
  selectedProducts = [],
  setSelectedProducts,
}) => {
  if (!product) return null

  const productLink = `/products/${product.product_id}`

  const toggleSelect = () => {
    setSelectedProducts((prev) => {
      if (prev.includes(product.product_id)) {
        return prev.filter((id) => id !== product.product_id)
      }
      return [...prev, product.product_id]
    })
  }

  const deleteProduct = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/products/${product.product_id}`,
        {
          method: "DELETE",
          credentials: "include",
        },
      )

      if (!res.ok) {
        const error = await res.json().catch(() => null)
        return alert(error?.message || "Delete failed")
      }

      alert("Product deleted successfully")
      setUpdated((prev) => !prev)
    } catch (err) {
      alert("Delete failed")
    }
  }

  return (
    <div
      className="AdminButtons m-0 mb-3 py-1 d-flex align-items-center"
      style={{ height: "20%" }}
    >
      {/* Checkbox */}
      <input
        type="checkbox"
        className="form-check-input mx-2"
        checked={selectedProducts.includes(product.product_id)}
        onChange={toggleSelect}
      />

      <Link
        to={productLink}
        className="btn btn-primary admin-btn mx-1 d-flex align-items-center"
      >
        View
      </Link>

      <button
        className="btn btn-primary admin-btn mx-1"
        type="button"
        onClick={() => {
          setCurrentProduct(product)

          setTimeout(() => {
            const modalElement = document.getElementById("editProductModal")
            const modal = Modal.getOrCreateInstance(modalElement)
            modal.show()
          }, 0)
        }}
      >
        Edit
      </button>

      <button className="btn btn-danger admin-btn mx-1" onClick={deleteProduct}>
        Delete
      </button>
    </div>
  )
}

export default AdminCardButtons
